<script setup>

import { computed, defineProps } from 'vue'

const props = defineProps(['size', 'inline', 'invertColor'])

const computedStyle = computed(() => {
  const lds2 = props.size * 0.8
  return {'--lds-color': props.invertColor ? '#ffffff' : '#232D45',
          '--lds-size': `${props.size}px`,
          '--lds-size-sm': `${lds2}px` }
})

</script>

<template>
  <div :style="computedStyle" :class="props.inline ? 'inline-flex' : 'flex'" class="items-center justify-center"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
</template>

<style scoped>

.lds-ring {
  display: inline-block;
  position: relative;
  width: var(--lds-size);
  height: var(--lds-size);
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: var(--lds-size-sm);
  height: var(--lds-size-sm);
  margin: 2px;
  border: 2px solid var(--lds-color);
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--lds-color) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>